import Filter from './Filter';
import * as fields from './fields';
import getFilterValue from './getFilterValue';
import { useContext as useFilter } from './context';
import withFilterValue from './withFilterValue';
import SearchInput from './SearchInput';
import FilterProvider from './FilterProvider';
import FilterOuter from './FilterOuter';
import pickSelectValues from './pickSelectValues';
import createFilterValueMapper from './createFilterValueMapper';
import useUrlFilter, { createUrlParamsReader, stripConsumedUrlParams } from './useUrlFilter';
import useUrlFilterValue from './useUrlFilterValue';
import filterToUrlParams, { parseFilterEntry, takeFilterEntry, createUrlFilterReader } from './filterToUrlParams';
import filterInterceptors, { singleSelectInterceptor, multiSelectInterceptor } from './filterInterceptors';

Filter.fields = fields;
Filter.getFilterValue = getFilterValue;
Filter.useFilter = useFilter;
Filter.SearchInput = SearchInput;
Filter.withFilterValue = withFilterValue;
Filter.FilterProvider = FilterProvider;
Filter.FilterOuter = FilterOuter;

Filter.pickSelectValues = pickSelectValues;
Filter.createFilterValueMapper = createFilterValueMapper;
Filter.useUrlFilter = useUrlFilter;
Filter.useUrlFilterValue = useUrlFilterValue;
Filter.createUrlParamsReader = createUrlParamsReader;
Filter.stripConsumedUrlParams = stripConsumedUrlParams;
Filter.filterToUrlParams = filterToUrlParams;
Filter.parseFilterEntry = parseFilterEntry;
Filter.takeFilterEntry = takeFilterEntry;
Filter.createUrlFilterReader = createUrlFilterReader;
Filter.filterInterceptors = filterInterceptors;
Filter.singleSelectInterceptor = singleSelectInterceptor;
Filter.multiSelectInterceptor = multiSelectInterceptor;

export default Filter;
export {
  fields,
  getFilterValue,
  useFilter,
  withFilterValue,
  SearchInput,
  FilterProvider,
  pickSelectValues,
  createFilterValueMapper,
  useUrlFilter,
  useUrlFilterValue,
  createUrlParamsReader,
  stripConsumedUrlParams,
  filterToUrlParams,
  parseFilterEntry,
  takeFilterEntry,
  createUrlFilterReader,
  filterInterceptors,
  singleSelectInterceptor,
  multiSelectInterceptor
};
export { default as AdvancedFilter } from './AdvancedFilter';
export { default as FilterValueDisplay } from './FilterValueDisplay';
export { default as FilterItem } from './FilterItem';
export { default as FilterLines } from './FilterLines';
export { default as FilterOuter } from './FilterOuter';
export { default as PopoverItem } from './PopoverItem';
export { default as withFieldItem } from './withFieldItem';
export { default as FilterItemContainer } from './FilterItemContainer';
export { default as TypeDateRangePickerField } from './common/TypeDateRangePickerField';
export {
  NumberRangeFilterItem,
  InputFilterItem,
  DatePickerFilterItem,
  DateRangePickerFilterItem,
  TypeDateRangePickerFilterItem,
  SuperSelectFilterItem,
  SelectTableListFilterItem,
  SelectTreeFilterItem,
  SelectCascaderFilterItem,
  SelectFunctionFilterItem,
  SelectIndustryFilterItem,
  SelectAddressFilterItem
} from './fields';
